import parse from "date-fns/parse";
import { ptBR } from "date-fns/locale";

export default function parseDateYmd(date: string) {
  return parse(date, "yyyy-MM-dd", new Date(), {
    locale: ptBR,
  });
}
